import { useEffect } from "react";
import apiClient, { setSessionRefreshState } from "@shared/services/apiClient";
import logger from "@shared/utils/logger";
import {
  beginActiveTransfer,
  endActiveTransfer,
} from "./activeTransferRegistry";

const HEARTBEAT_INTERVAL_MS = 4 * 60 * 1000;

async function extendSessionQuietly(): Promise<void> {
  try {
    const response = await apiClient.post("/users/extend-session");
    const payload = response?.data?.data ?? response?.data;
    const expiresInSeconds =
      Number(payload?.expiresIn) > 0 ? Number(payload.expiresIn) : 1800;
    setSessionRefreshState({
      isAuthenticated: true,
      tokenExpiryMs: Date.now() + expiresInSeconds * 1000,
    });
  } catch (error) {
    logger.warn("Failed to keep session alive during transfer", error);
  }
}

export function useKeepSessionAliveDuringTransfer(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return undefined;

    beginActiveTransfer();
    void extendSessionQuietly();
    const timer = window.setInterval(() => {
      void extendSessionQuietly();
    }, HEARTBEAT_INTERVAL_MS);

    return () => {
      window.clearInterval(timer);
      endActiveTransfer();
    };
  }, [enabled]);
}
